import Divisions from './Divisions.svelte'

if(document.getElementById('our-divisions')){
  const divisions = new Divisions({
    target: document.getElementById('our-divisions'),
  });
}

